document.querySelectorAll('.section-resources__card-text-toggle:not([data-init])').forEach((button) => {
    button.dataset.init = '1';

    const card = button.closest('.section-resources__card');
    const textBox = card.querySelector('.section-resources__card-text');

    if (textBox.scrollHeight <= textBox.clientHeight) {
        button.style.display = 'none';
        textBox.classList.add('section-resources__card-text--expanded');
        return;
    }

    button.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = card.classList.contains('section-resources__card--expanded');

        card.classList.toggle('section-resources__card--expanded', !isExpanded);
        textBox.classList.toggle('section-resources__card-text--expanded', !isExpanded);
        button.textContent = isExpanded ? 'Voir plus' : 'Voir moins';
    });
});
